<template>
    <div>404: Not found</div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    name: 'NotFound',
})
</script>
